import { ChangeEvent, InputHTMLAttributes, forwardRef } from 'react'

import './style.scss'

interface RadioProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string,
  error?: boolean,
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
}

type Ref = HTMLInputElement;

const Radio = forwardRef<Ref, RadioProps>(({ className = '', error, onChange, ...rest }, ref)  => {
  return (
    <input type="radio" ref={ref} className={`radio ${error ? 'radio--error' : ''} ${className}`} onChange={onChange} {...rest} />
  )
})

export { Radio }